import ModuleMultiSelect from './ModuleMultiSelect';

export default class TeamSelect extends ModuleMultiSelect
{
	Type = 'TEAM';
};

